module.exports = __webpack_public_path__ + "static/media/academy-sports.05150d95.mov";